import { TimePicker } from "components";
import moment from "moment";
import React from "react";
import { formatTime } from "utilities";

interface Props {
  value: server.dto.Doors;
  onChange: (value: server.dto.Doors) => void;
}

export const DoorsEdit = (props: Props) => {
  const doorsOpenMoment = props.value.open ? moment.utc(props.value.open.cultureInvariant, "HH:mm") : null;
  const doorsCloseMoment = props.value.close ? moment.utc(props.value.close.cultureInvariant, "HH:mm") : null;

  return <div className="flex-column gap">
    <div className="flex gap">
      <div>
        <TimePicker
          canBeEmpty
          value={doorsOpenMoment}
          onChange={(value) => props.onChange({
            ...props.value,
            open: value ? { cultureInvariant: value.format("HH:mm"), localized: formatTime(value) } : null
          })}
        />
      </div>
      <div>
        {RESX.Venue.Open}
      </div>
    </div>
    <div className="flex gap">
      <div>
        <TimePicker
          canBeEmpty
          value={doorsCloseMoment}
          onChange={(value) => props.onChange({
            ...props.value,
            close: value ? { cultureInvariant: value.format("HH:mm"), localized: formatTime(value) } : null
          })}
        />
      </div>
      <div>
        {RESX.Venue.Close}
      </div>
    </div>
  </div>
}